import '@Application/Bootstrap';

import autoload from '@123/druid/dist/Framework/Decorators/Autoload';
import component from '@123/druid/dist/Framework/Decorators/Component';
import View from '@123/druid/dist/Framework/View/View';
import AidenAdvisorView from '@Component/Aiden/AidenAdvisorView';
import AlternativeButtonView from '../../../Component/Recommendation/Button/AlternativeButtonView';
import EventHub from '@Service/LegacyBridge/EventHub/EventHub';

@autoload
@component
export default class ProductListModuleView extends View {
    protected mounted(): void {
        this.getViews(AidenAdvisorView);
        this.getViews(AlternativeButtonView);
        this.addEventHubListeners();
    }

    private addEventHubListeners(): void {
        EventHub.instance.on('ResultList.Updated', () => {
            this.getViews(AlternativeButtonView);
        });
    }
}
